export default __webpack_public_path__ + "static/media/Ndu.78ad8472.jpg";